import type { AlertSize, AlertStyle } from "./Alert";

export const SIZE_CLASS_MAP: Record<AlertSize, string> = {
  small: "sm:max-w-xs",
  medium: "sm:max-w-sm",
  large: "sm:max-w-md",
};

export const STYLE_VARIANT_MAP: Record<AlertStyle, "destructive" | "default"> =
  {
    danger: "destructive",
    warning: "default",
  };
